export interface BackgroundPreset {
  id: string
  name: string
  path: string
  thumbnail?: string
}

export const BACKGROUND_PRESETS: BackgroundPreset[] = [
  {
    id: 'stone',
    name: '石纹',
    path: '/src/assets/background/bg-stone.jpg',
  },
]